import React, { useEffect, useState } from "react";
import { Collapse, Modal, Button, Alert } from "react-bootstrap";

const JuniorWingAdmin = () => {
  const BASE_URL = "https://admin.vascularirdoctors.com/backend";

  const [collapseBtn, setCollapseBtn] = useState(true);
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    role: "",
    facebook: "",
    twitter: "",
    linkedin: "",
  });

  const [image, setImage] = useState(null);

  const [alert, setAlert] = useState({
    show: false,
    type: "",
    text: "",
  });

  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editImage, setEditImage] = useState(null);

  const [editData, setEditData] = useState({
    name: "",
    role: "",
    facebook: "",
    twitter: "",
    linkedin: "",
    image: "",
  });

  const showAlert = (type, text) => {
    setAlert({ show: true, type, text });
    setTimeout(() => {
      setAlert({ show: false, type: "", text: "" });
    }, 3000);
  };

  const fetchMembers = async () => {
    try {
      const res = await fetch(`${BASE_URL}/junior-wing`);
      const data = await res.json();
      setMembers(data);
    } catch (err) {
      console.log("FETCH MEMBERS ERROR:", err);
      showAlert("danger", "Unable to fetch members.");
    }
  };

  useEffect(() => {
    fetchMembers();
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleImage = (e) => {
    setImage(e.target.files[0]);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("role", formData.role);
      data.append("facebook", formData.facebook);
      data.append("twitter", formData.twitter);
      data.append("linkedin", formData.linkedin);
      if (image) data.append("image", image);

      const res = await fetch(`${BASE_URL}/junior-wing`, {
        method: "POST",
        body: data,
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Junior Wing member added successfully.");
        setFormData({
          name: "",
          role: "",
          facebook: "",
          twitter: "",
          linkedin: "",
        });
        setImage(null);

        // reset file input visually
        document.getElementById("juniorWingImageInput").value = "";

        fetchMembers();
      } else {
        showAlert("danger", result.message || "Failed to add member.");
      }
    } catch (err) {
      console.log("SUBMIT ERROR:", err);
      showAlert("danger", "Unable to connect to server.");
    }

    setLoading(false);
  };

  const confirmDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const deleteMember = async () => {
    try {
      const res = await fetch(`${BASE_URL}/junior-wing/${deleteId}`, {
        method: "DELETE",
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Member deleted successfully.");
        fetchMembers();
      } else {
        showAlert("danger", result.message || "Delete failed.");
      }
    } catch (err) {
      console.log("DELETE ERROR:", err);
      showAlert("danger", "Unable to delete member.");
    }

    setShowDeleteModal(false);
    setDeleteId(null);
  };

  const openEditModal = (member) => {
    setEditId(member.id);
    setEditData({
      name: member.name || "",
      role: member.role || "",
      facebook: member.facebook || "",
      twitter: member.twitter || "",
      linkedin: member.linkedin || "",
      image: member.image || "",
    });
    setEditImage(null);
    setShowModal(true);
  };

  const handleEditChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value,
    });
  };

  const handleEditImage = (e) => {
    setEditImage(e.target.files[0]);
  };

  const updateMember = async () => {
    try {
      const data = new FormData();
      data.append("name", editData.name);
      data.append("role", editData.role);
      data.append("facebook", editData.facebook);
      data.append("twitter", editData.twitter);
      data.append("linkedin", editData.linkedin);
      if (editImage) data.append("image", editImage);

      const res = await fetch(`${BASE_URL}/junior-wing/${editId}`, {
        method: "PUT",
        body: data,
      });

      const result = await res.json();

      if (res.ok) {
        showAlert("success", "Member updated successfully.");
        setShowModal(false);
        fetchMembers();
      } else {
        showAlert("danger", result.message || "Update failed.");
      }
    } catch (err) {
      console.log("UPDATE ERROR:", err);
      showAlert("danger", "Unable to update member.");
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="row page-titles align-items-center">
            <div className="col-sm-6">
              <ol className="breadcrumb mt-sm-0 mt-2">
                <li className="breadcrumb-item active" aria-current="page">
                  Junior Wing Members
                </li>
              </ol>
            </div>

            <div className="col-sm-6 text-sm-end mt-2 mt-sm-0">
              <button
                type="button"
                className="btn btn-outline-danger btn-sm"
                onClick={() => setCollapseBtn(false)}
              >
                <i className="fas fa-times me-1"></i> Close
              </button>
            </div>
          </div>
        </div>

        {alert.show && (
          <div className="col-xl-12">
            <Alert variant={alert.type} className="shadow-sm rounded-3">
              {alert.text}
            </Alert>
          </div>
        )}

        {/* ADD FORM */}
        <div className="col-xl-12">
          <div className="filter cm-content-box box-primary">
            <div className="content-title d-flex justify-content-between align-items-center">
              <div className="cpa">
                <i className="fas fa-user-plus me-1"></i>Add Junior Wing Member
              </div>
              <div className="tools">
                <button
                  type="button"
                  className="btn btn-sm btn-light border"
                  onClick={() => setCollapseBtn(!collapseBtn)}
                >
                  <i
                    className={`fas ${
                      collapseBtn ? "fa-angle-up" : "fa-angle-down"
                    }`}
                  ></i>
                </button>
              </div>
            </div>

            <Collapse in={collapseBtn}>
              <div className="cm-content-body form excerpt">
                <div className="card-body">
                  <form onSubmit={submitHandler}>
                    <div className="row">
                      <div className="col-xl-6">
                        <div className="mb-3">
                          <label className="form-label">Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter member name"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Role</label>
                          <input
                            type="text"
                            className="form-control"
                            name="role"
                            value={formData.role}
                            onChange={handleChange}
                            placeholder="Example: President"
                            required
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Facebook</label>
                          <input
                            type="text"
                            className="form-control"
                            name="facebook"
                            value={formData.facebook}
                            onChange={handleChange}
                            placeholder="Facebook profile link"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Twitter</label>
                          <input
                            type="text"
                            className="form-control"
                            name="twitter"
                            value={formData.twitter}
                            onChange={handleChange}
                            placeholder="Twitter profile link"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">LinkedIn</label>
                          <input
                            type="text"
                            className="form-control"
                            name="linkedin"
                            value={formData.linkedin}
                            onChange={handleChange}
                            placeholder="LinkedIn profile link"
                          />
                        </div>
                      </div>

                      <div className="col-xl-6">
                        <div className="mb-3">
                          <label className="form-label">Upload Image</label>
                          <input
                            id="juniorWingImageInput"
                            type="file"
                            className="form-control"
                            onChange={handleImage}
                            accept="image/*"
                          />
                        </div>

                        {image && (
                          <div className="mb-3">
                            <img
                              src={URL.createObjectURL(image)}
                              alt="Preview"
                              style={{
                                width: "100%",
                                maxHeight: "300px",
                                objectFit: "cover",
                                borderRadius: "12px",
                                border: "1px solid #ddd",
                              }}
                            />
                          </div>
                        )}
                      </div>

                      <div className="col-xl-12 text-end">
                        <button
                          type="submit"
                          className="btn btn-primary"
                          disabled={loading}
                        >
                          {loading ? "Saving..." : "Save Member"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Collapse>
          </div>
        </div>

        {/* LIST TABLE */}
        <div className="col-xl-12 mt-4">
          <div className="filter cm-content-box box-primary">
            <div className="content-title">
              <div className="cpa">
                <i className="fas fa-users me-1"></i>Uploaded Members
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>Name</th>
                      <th>Role</th>
                      <th>Facebook</th>
                      <th>Twitter</th>
                      <th>LinkedIn</th>
                      <th style={{ width: "170px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {members.length > 0 ? (
                      members.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <img
                              src={
                                item.image
                                  ? `${BASE_URL}${item.image}`
                                  : "https://via.placeholder.com/90x60?text=No+Image"
                              }
                              alt={item.name}
                              style={{
                                width: "90px",
                                height: "60px",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          </td>
                          <td>{item.name}</td>
                          <td>{item.role}</td>
                          <td>{item.facebook || "-"}</td>
                          <td>{item.twitter || "-"}</td>
                          <td>{item.linkedin || "-"}</td>
                          <td>
                            <button
                              className="btn btn-sm btn-info me-2"
                              onClick={() => openEditModal(item)}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => confirmDelete(item.id)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center">
                          No members found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* EDIT MODAL */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Junior Wing Member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Name</label>
              <input
                type="text"
                className="form-control"
                name="name"
                value={editData.name}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Role</label>
              <input
                type="text"
                className="form-control"
                name="role"
                value={editData.role}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Facebook</label>
              <input
                type="text"
                className="form-control"
                name="facebook"
                value={editData.facebook}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Twitter</label>
              <input
                type="text"
                className="form-control"
                name="twitter"
                value={editData.twitter}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-12 mb-3">
              <label>LinkedIn</label>
              <input
                type="text"
                className="form-control"
                name="linkedin"
                value={editData.linkedin}
                onChange={handleEditChange}
              />
            </div>

            <div className="col-md-12 mb-3">
              <label>Change Image</label>
              <input
                type="file"
                className="form-control"
                onChange={handleEditImage}
                accept="image/*"
              />
            </div>

            <div className="col-md-12">
              <img
                src={
                  editImage
                    ? URL.createObjectURL(editImage)
                    : editData.image
                    ? `${BASE_URL}${editData.image}`
                    : "https://via.placeholder.com/600x250?text=No+Image"
                }
                alt="Preview"
                style={{
                  width: "100%",
                  maxHeight: "250px",
                  objectFit: "cover",
                  borderRadius: "10px",
                }}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={updateMember}>
            Update Member
          </Button>
        </Modal.Footer>
      </Modal>

      {/* DELETE MODAL */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Member</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this member? This action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={deleteMember}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default JuniorWingAdmin;